import { render } from "./FinancialLifeView.vue?vue&type=template&id=945eb72e&scoped=true"
import script from "./FinancialLifeView.vue?vue&type=script&lang=js"
export * from "./FinancialLifeView.vue?vue&type=script&lang=js"

import "./FinancialLifeView.vue?vue&type=style&index=0&id=945eb72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945eb72e"]])

export default __exports__